var NumberFormatter = Object.create(null);

/**
 * @typedef {object} PriceObj
 * @property {number} htPriceWithoutOffer - Prix HT sans remise
 * @property {number} ttcPriceWithoutOffer - Prix TTC sans remise
 * @property {number} htPrice - Prix HT avec remise
 * @property {number} ttcPrice - Prix TTC avec remise
 * @property {number} totalHtPriceWithoutOffer - Prix total HT sans remise
 * @property {number} totalTtcPriceWithoutOffer - Prix total TTC sans remise
 * @property {number} totalHtPrice - Prix total HT avec remise
 * @property {number} totalTtcPrice - Prix total TTC avec remise
 */

NumberFormatter.formatNumberForBase = formatNumberForBase;
NumberFormatter.formatNumber = formatNumber;
NumberFormatter.formatDecimalStrWithTwoDecimals = formatDecimalStrWithTwoDecimals;
NumberFormatter.formatTva = formatTva;
NumberFormatter.getHtPrice = getHtPrice;
NumberFormatter.calculTtcPrice = calculTtcPrice;
NumberFormatter.calculHtPrice = calculHtPrice;
NumberFormatter.formatNumberForCsv = formatNumberForCsv;
NumberFormatter.getTotalTtcPrice = getTotalTtcPrice;
NumberFormatter.getPriceObj = getPriceObj;
NumberFormatter.getIdInString = getIdInString;

/**
 * Formattage d'un nombre pour la base de données
 * @param {any} number - Nombre à formatter
 * @param {number} [decimal] - Nombre de décimal
 * @returns {?number} Nombre formatter avec les bonnes décimales ou null si le nombre n'est pas valide
 * TU DONE 🗸
 */
function formatNumberForBase(number, decimal) {
  if (number === null || number === undefined || number === '') {
    return null;
  }

  let n = Number(number);

  if (isNaN(n)) {
    return null;
  }

  if (typeof decimal === 'number') {
    const factor = Math.pow(10, decimal);

    n = Math.round(n * factor) / factor;
  }

  return n;
}

/**
 * Formattage d'un nombre pour l'affichage
 * @param {string} number - Nombre à formatter
 * @param {string} ext - Extension à rajouter (€, %, $, etc)
 * @param {number} decimal - Nombre de décimal
 * @returns {string} Chaîne du nombre formatter avec l'extension, les bonnes décimales et les séparateurs de milliers
 * TU DONE 🗸
 */
function formatNumber(number, ext, decimal) {
  if (number === null) {
    return '-';
  }

  if (typeof decimal !== 'undefined') {
    number = decimal === 0 ? parseFloat(number).toFixed(0) + '' : parseFloat(number).toFixed(decimal) + '';
  } else {
    number = parseFloat(number).toFixed(2) + '';
  }

  var x = number.split('.'),
      x1 = x[0],
      x2 = x.length > 1 ? '.' + x[1] : '',
      rgx = /(\d+)(\d{3})/;

  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1' + ' ' + '$2');
  }
  if (!ext) {
    ext = '€';
  }
  return `${ x1 + x2 } ${ ext }`;
}

/**
 * Formattage d'un chiffre au format string pour l'affichage avec 2 décimales
 * @param {string} number - Chiffre au format string
 * @returns {string} Chiffre au formaté avec 2 décimales au format string
 */
function formatDecimalStrWithTwoDecimals(number) {
  if (number === null) {
    return '';
  }

  number = parseFloat(number).toFixed(2);

  var x = number.split('.'),
      x1 = x[0],
      x2 = x.length > 1 ? `.${ x[1] }` : '';

  return x1 + x2;
}

/**
 * Permet de récupérer le coéfficient multiplicateur de TVA à appliquer à un nombre pour y rajouter la TVA
 * @param {number} tva - TVA
 * @returns {number}
 * TU DONE 🗸
 */
function formatTva(tva) {
  return tva / 100 + 1;
}

/**
 * Permet de récupérer le prix HT à partir du prix TTC
 * @param {number} ttcPrice - Montant TTC
 * @param {number} tva - TVA appliquer au montant TTC
 * @returns {number} Le montnt HT
 * TU DONE 🗸
 */
function getHtPrice(ttcPrice, tva) {
  var htPrice = (ttcPrice * 100) / (100 + tva);

  return /** @type {number} */(formatNumberForBase(htPrice));
}

/**
 * Formattage d'un prix TTC en prenant en compté la quantité et les remises
 * @param {number} htPrice - Prix HT
 * @param {number} tva - TVA à appliquer
 * @param {number} quantity - Quantité
 * @param {number} offerAmountEuro - Remise en euros
 * @param {number} offerAmountPercent - Remise en pourcentage
 * @returns {number}
 * TU DONE 🗸
 */
function calculTtcPrice(htPrice, tva, quantity, offerAmountEuro, offerAmountPercent) {
  var totalHt = htPrice * quantity;

  if (offerAmountEuro || offerAmountPercent) {
    if (offerAmountEuro) {
      totalHt -= offerAmountEuro;
    } else if (offerAmountPercent) {
      totalHt = (totalHt * (100 - offerAmountPercent)) / 100;
    }
  }

  return /** @type {number} */(formatNumberForBase(totalHt * NumberFormatter.formatTva(tva)));
}

/**
 * Calcul d'un prix HT en prenant en compté la quantité et les remises
 * @param {any} htPrice - Prix HT
 * @param {number} quantity - Quantité à appliquer
 * @param {number} [offerAmountEuro] - Remise en euros
 * @param {number} [offerAmountPercent] - Remise en pourcentage
 * @returns {number}
 * TU DONE 🗸
 */
function calculHtPrice(htPrice, quantity, offerAmountEuro, offerAmountPercent) {
  var totalHt = htPrice * quantity;

  if (offerAmountEuro || offerAmountPercent) {
    if (offerAmountEuro) {
      totalHt -= offerAmountEuro;
    } else if (offerAmountPercent) {
      totalHt = (totalHt * (100 - offerAmountPercent)) / 100;
    }
  }

  return /** @type {number} */(formatNumberForBase(totalHt));
}

/**
 * Formattage d'un nombre pour les fichiers CSV
 * @param {string} number - Nombre à formatter
 * @param {boolean} separator - S'il faut les séparateurs de milliers
 * @returns {string} Chaîne du nombre avec la virgule
 * TU TODO 🔨
 */
function formatNumberForCsv(number, separator = true) {
  if (number === null) {
    return '';
  }

  number = parseFloat(number).toFixed(2) + '';

  var x = number.split('.'),
      x1 = x[0],
      x2 = x.length > 1 ? `,${ x[1] }` : '',
      rgx = /(\d+)(\d{3})/;

  if (separator) {
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + ' ' + '$2');
    }
  }

  return x1 + x2;
}

/**
 * Permet de récupérer le prix TTC total en fonction de la quantité et des remises
 * @param {number} ttcPrice - Montant TTC
 * @param {number} quantity - Quantité
 * @param {number} offerAmountEuro - Remise en euros
 * @param {number} offerAmountPercent - Remise en %
 * @returns {number} Le montant TTC total
 * TU TODO 🔨
 */
function getTotalTtcPrice(ttcPrice, quantity, offerAmountEuro, offerAmountPercent) {
  var totalTtc = ttcPrice * quantity;

  if (offerAmountEuro) {
    totalTtc -= offerAmountEuro;
  } else if (offerAmountPercent) {
    totalTtc = (totalTtc * (100 - offerAmountPercent)) / 100;
  }

  return /** @type {number} */(formatNumberForBase(totalTtc));
}

/**
 * Permet de récupérer un objet avec le montant total HT et TTC
 * @param {number} htPrice - Montant HT
 * @param {number} tva - TVA à appliquer
 * @param {number} quantity - Quantité
 * @param {number} offerAmountEuro - Remise en euros
 * @param {number} offerAmountPercent - Remise en %
 * @returns {PriceObj} L'objet avec les montants HT et TTC totaux
 * TU NONEED 🧊
 */
function getPriceObj(htPrice, tva, quantity, offerAmountEuro, offerAmountPercent) {
  var obj = {},
      totalHt = htPrice * quantity,
      totalHtWithoutOffer = htPrice * quantity,
      htPriceWithOffer = htPrice;

  if (offerAmountEuro || offerAmountPercent) {
    if (offerAmountEuro) {
      totalHt -= offerAmountEuro;
      htPriceWithOffer -= offerAmountEuro;
    } else if (offerAmountPercent) {
      totalHt = (totalHt * (100 - offerAmountPercent)) / 100;
      htPriceWithOffer = (htPriceWithOffer * (100 - offerAmountPercent)) / 100;
    }
  }

  obj.htPriceWithoutOffer = /** @type {number} */(formatNumberForBase(htPrice));
  obj.ttcPriceWithoutOffer = /** @type {number} */(formatNumberForBase(htPrice * NumberFormatter.formatTva(tva)));

  obj.htPrice = /** @type {number} */(formatNumberForBase(htPriceWithOffer));
  obj.ttcPrice = /** @type {number} */(formatNumberForBase(htPriceWithOffer * NumberFormatter.formatTva(tva)));

  obj.totalHtPriceWithoutOffer = /** @type {number} */(formatNumberForBase(totalHtWithoutOffer));
  obj.totalTtcPriceWithoutOffer = /** @type {number} */(formatNumberForBase(totalHtWithoutOffer * NumberFormatter.formatTva(tva)));

  obj.totalHtPrice = /** @type {number} */(formatNumberForBase(totalHt));
  obj.totalTtcPrice = /** @type {number} */(formatNumberForBase(totalHt * NumberFormatter.formatTva(tva)));

  return obj;
}

/**
 * Permet de récupérer une chaîne à partir d'un identifiant en précisant le nombre de caractères souhaité
 * @exemple getIdInString(1, 6) => "000001"
 * @example getIdInString(123, 6) => "000123"
 * @param {number} id - Identifiant à formatter
 * @param {number} length - Nombre de caractères souhaité
 * @returns {string} Chaîne de caractère avec l'identifiant formaté
 * TU TODO 🔨
 */
function getIdInString(id, length) {
  var idStr = id.toString();

  while (idStr.length < length) {
    idStr = `0${ idStr }`;
  }

  return idStr;
}

module.exports = NumberFormatter;
